import { dictionaryGrlsApi, receptionApi, dictionaryMkb10Api } from '../services';

export default {
    actions: {
        async getSlots(ctx, obj) {
          //  const dat = new Date();
            const format = 'YYYY-MM-DD';
            const fdat = moment(obj.dat).format(format);
            const slots = await receptionApi.getMyReception(obj.emp, fdat, fdat);
            ctx.commit('updateSlots', slots);
        },
        async getCurrentPatient(ctx, patient) {
            ctx.commit('updateCurrentPatient', patient);
            console.log(patient);
        },
        async getDiagnoses(ctx, str) {
            const diagnoses = await dictionaryMkb10Api.getAll(undefined, undefined, str);
            ctx.commit('updateDiagnoses', diagnoses.items);
        },
        async getRecepts(ctx, str) {
            const recepts = await dictionaryGrlsApi.getAll(undefined, undefined, str);
            ctx.commit('updateRecepts', recepts.items);
        },
        async clearDiagnoses(ctx) {
            ctx.commit('updateDiagnoses', []);
        },
        async clearSlots(ctx) {
            ctx.commit('updateSlots', []);
        }
    },
    mutations: {
        updateSlots(state, slots) {
            state.slots = slots;
        },
        updateCurrentPatient(state, current_patient) {
            state.current_patient = current_patient;
        },
        updateDiagnoses(state, diagnoses) {
            state.diagnoses = diagnoses;
        },
        updateRecepts(state, recepts) {
            state.recepts = recepts;
        }
    },
    state: {
        slots: [],
        current_patient: {},
        diagnoses: [],
        recepts: []
    },
    getters: {
        allSlots(state) {
            return state.slots;
        },
        currentPatient(state) {
            return state.current_patient;
        },
        getDiagnoses(state) {
            return state.diagnoses;
        },
        getRecepts(state) {
            return state.recepts;
        }
    }
};